// frontend/src/components/Logo.jsx
import React from "react";

/**
 * Composant Logo SE Engineering
 *
 * @param {string} size - Taille: 'sm', 'md', 'lg', 'xl' (défaut: 'md')
 * @param {boolean} showText - Afficher le texte (défaut: true)
 * @param {string} textColor - Couleur du texte (défaut: 'text-blue-600')
 * @param {string} className - Classes CSS supplémentaires
 */
const Logo = ({
  size = "md",
  showText = true,
  textColor = "text-blue-600",
  className = "",
}) => {
  // Tailles du logo
  const sizes = {
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
  };

  // Tailles du texte
  const textSizes = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-3xl",
    xl: "text-4xl",
  };

  const logoSize = sizes[size] || sizes.md;
  const textSize = textSizes[size] || textSizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="/logoSEEV2.png"
        alt="SE Engineering Logo"
        className={`${logoSize} object-contain transition-transform hover:scale-110`}
        onError={(e) => {
          // Si le logo n'existe pas, afficher un logo par défaut SVG
          e.target.style.display = "none";
          // Afficher un logo générique à la place
          const parent = e.target.parentElement;
          if (parent && !parent.querySelector(".default-logo")) {
            const defaultLogo = document.createElement("div");
            defaultLogo.className = `default-logo ${logoSize} bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center text-white font-bold ${
              size === "sm" ? "text-xs" : size === "md" ? "text-sm" : "text-lg"
            }`;
            defaultLogo.textContent = "SE";
            parent.insertBefore(defaultLogo, parent.firstChild);
          }
        }}
      />
      {showText && (
        <span className={`${textSize} font-bold ${textColor}`}>
          SE Engineering
        </span>
      )}
    </div>
  );
};

export default Logo;

// ==========================================
// Exemples d'utilisation :
// ==========================================

/*
// Navbar - Logo moyen avec texte
<Logo size="md" />

// Footer - Logo large avec texte
<Logo size="lg" />

// Mobile - Logo petit
<Logo size="sm" />

// Logo seul sans texte
<Logo showText={false} />

// Logo avec texte blanc (pour fond sombre)
<Logo textColor="text-white" />

// Logo extra large pour page d'accueil
<Logo size="xl" />

// Logo avec classes personnalisées
<Logo className="hover:opacity-80 transition-opacity" />
*/
